import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_certified-solutions-1/artifacts/9df5mn58_banner%20bpo%20solutions%20eood%202025%20%20horizontaal%20X.png";

const NAV = [
    { label: "Services", href: "#services" },
    { label: "Approach", href: "#approach" },
    { label: "Who we serve", href: "#who-we-serve" },
    { label: "Standards", href: "#standards" },
    { label: "Contact", href: "#contact" },
];

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`sticky top-0 z-50 transition-all ${
                scrolled
                    ? "bg-white/90 backdrop-blur-xl border-b border-gray-100 shadow-[0_2px_20px_rgba(0,0,0,0.03)]"
                    : "bg-white/70 backdrop-blur-md border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="flex items-center justify-between h-20 md:h-24">
                    <a
                        href="#top"
                        data-testid="header-logo-link"
                        className="flex items-center gap-3 group"
                    >
                        <img
                            src={LOGO_URL}
                            alt="Business Performance Outlook — BPO Solutions"
                            className="h-12 md:h-14 w-auto object-contain transition-transform group-hover:-translate-y-0.5"
                        />
                    </a>

                    <nav className="hidden lg:flex items-center gap-9">
                        {NAV.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-sm font-medium text-bpo-charcoal hover:text-bpo-cyan transition-colors"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>

                    <div className="hidden lg:flex items-center gap-3">
                        <a
                            href="https://app.kadonetworks.com/kado/bposolutions"
                            target="_blank"
                            rel="noreferrer noopener"
                            data-testid="header-kado-link"
                            className="text-sm font-semibold text-bpo-ink hover:text-bpo-cyan transition-colors"
                        >
                            Digital card →
                        </a>
                        <a
                            href="#contact"
                            data-testid="header-cta-button"
                            className="inline-flex items-center gap-2 bg-bpo-ink hover:bg-bpo-charcoal text-white font-semibold text-sm py-2.5 px-5 rounded-full transition-all hover:-translate-y-0.5 shadow-sm"
                        >
                            Book a discovery call
                        </a>
                    </div>

                    <button
                        type="button"
                        data-testid="mobile-nav-toggle"
                        onClick={() => setOpen((s) => !s)}
                        className="lg:hidden p-2 rounded-lg border border-gray-200"
                        aria-label="Toggle menu"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>

                {open && (
                    <div
                        data-testid="mobile-nav-panel"
                        className="lg:hidden pb-6 border-t border-gray-100 pt-4 flex flex-col gap-4"
                    >
                        {NAV.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-bpo-charcoal text-base font-medium"
                            >
                                {item.label}
                            </a>
                        ))}
                        <a
                            href="#contact"
                            onClick={() => setOpen(false)}
                            data-testid="mobile-cta-button"
                            className="mt-2 inline-flex justify-center bg-bpo-ink text-white font-semibold py-3 rounded-full"
                        >
                            Book a discovery call
                        </a>
                    </div>
                )}
            </div>
        </header>
    );
}
